
import { useState, useEffect } from 'react';
import { NoRecords } from '../../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { TopupTransaction } from '../index';
import { Search, Check, Copy, ExternalLink } from 'lucide-react';
import { useDebounce } from '../../../hooks/debounce';
import { useParams } from 'react-router-dom';
import { formatAddress } from '../../../utils/formatAddress';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useModalContext } from '../../../contexts/ModalContext';
import { useToast } from '../../../hooks/usetoast';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import { displayValue } from '../../../hooks/export';

function TopupHistory() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const { theme } = useModalContext();
    const toast = useToast();
    const searchText = useDebounce(search);
    const [double, setDouble] = useState(false);
    const { id } = useParams();
    const [fromEmail, setFromEmail] = useState(false);
    const [fromAddress, setFromAddress] = useState(false);
    const [toAddress, setToAddress] = useState(false);
    const { data: getTransactionHistory, isLoading } = TopupTransaction({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: "desc",
        type: "CardTopup"
    });

    const totalRecords = getTransactionHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);

    const copytxnhashAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data.txnHash)
        toast.success("Copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }
    const copyUserEmailAddress = async data => {
        setFromEmail(data._id)
        await copyToClipboard(data?.senderEmail)
        toast.success("Copied")
        setTimeout(() => {
            setFromEmail()
        }, 800)
    }
    const copyFromAddress = async data => {
        setFromAddress(data._id)
        await copyToClipboard(data?.fromAddress)
        toast.success("Copied")
        setTimeout(() => {
            setFromAddress()
        }, 800)
    }

    const copyToAddress = async data => {
        setToAddress(data._id)
        await copyToClipboard(data?.toAddress)
        toast.success("Copied")
        setTimeout(() => {
            setToAddress()
        }, 800)
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'History' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const copyOrderId = async data => {

        await copyToClipboard(data?.order_id)
        toast.success("Copied")

    }
    const renderInternalTransactionHistoryTable = () => (
        getTransactionHistory?.data?.transactionHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="internal transaction history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Email</TableCell>
                                    <TableCell className='text-nowrap' align="center">Order Id</TableCell>
                                    <TableCell className='text-nowrap' align="center">From Address</TableCell>
                                    <TableCell className='text-nowrap' align="center">To Address</TableCell>
                                    <TableCell className='text-nowrap' align="center">Txn Hash</TableCell>
                                    <TableCell className='text-nowrap' align="center">Amount</TableCell>
                                    <TableCell className='text-nowrap' align="center">Status</TableCell>
                                    <TableCell className='text-nowrap' align="center">
                                        Date & Time{' '}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getTransactionHistory?.data?.transactionHistory?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell className='text-nowrap' align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">
                                            {row?.senderEmail || "-"}
                                            {fromEmail === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.order_id || "-"}
                                            <Copy
                                                onClick={() => copyOrderId(row)}
                                                size={20}
                                                className="ml-5"
                                                style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                            />

                                        </TableCell>
                                        <TableCell align="center">
                                            {formatAddress(row?.fromAddress || "-")}
                                            {fromAddress === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyFromAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="center">
                                            {formatAddress(row?.toAddress || "-")}
                                            {toAddress === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyToAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.txnHash ? (
                                                <>
                                                    {`${row.txnHash.slice(0, 3)}...${row.txnHash.slice(-3)}`}
                                                    {double === row._id ? (
                                                        <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                    ) : (
                                                        <Copy
                                                            onClick={() => copytxnhashAddress(row)}
                                                            size={20}
                                                            className="ml-5"
                                                            style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                        />
                                                    )}
                                                    <a
                                                        href={row.explorerUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="ml-2"
                                                    >
                                                        <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                                                    </a>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </TableCell>



                                        <TableCell className="text-nowrap" align="center">
                                            {row?.sentAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                    {displayValue(row.sentAmount, 6)}

                                                    {row?.currencyImage && (
                                                        <img
                                                            src={row.currencyImage}
                                                            alt="Currency Icon"
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '50%',
                                                                verticalAlign: 'middle',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        <TableCell className="text-nowrap" align="center">
                                            <span style={{ color: row?.transactionStatus == 'Completed' ? "green" : "red", fontWeight: 600 }}>
                                                {row?.transactionStatus}
                                            </span>
                                        </TableCell>
                                        <TableCell className='text-nowrap' align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        const tableContent = renderInternalTransactionHistoryTable();
        content = (
            <section>
                <h4>Topup Transaction History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-md-4">
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color="#aaa9a9" />
                                </span>
                                <input
                                    type="text"
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Email"
                                />
                            </div>
                        </div>
                    </div>
                    {tableContent}
                </div>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

export default TopupHistory;